// src/components/MobileFindBar.jsx  —  ohapotato v2026.10.36
// On mobile: fires onFind() then scrolls to the results section
import React from 'react';
import FindButton from './FindButton';

export default function MobileFindBar({ count, nonStapleCount, onClick, loading, resultsRef }) {
  const handleClick = () => {
    onClick();
    // Give React one tick to kick off the search, then scroll
    setTimeout(() => {
      if (resultsRef?.current) {
        resultsRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }, 80);
  };

  return (
    <div className="mobile-find-bar">
      <FindButton count={count} nonStapleCount={nonStapleCount} onClick={handleClick} loading={loading} />
    </div>
  );
}
